<div class="rich-tooltip" role="tooltip" aria-hidden="false" [attr.id]="tooltipId">
  <ng-container [ngTemplateOutlet]="tooltipContent" [ngTemplateOutletContext]="{ tooltipContext }"></ng-container>
</div>
